module.exports = __webpack_public_path__ + "06_long_yellow.178c1f06.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/06_long_yellow.png
// module id = lIlU
// module chunks = 0